import { inject } from "vue";
import { createRouter, createWebHistory, routeLocationKey } from "vue-router";
const routes = [
  {
    path: "/",
    component: () => import("../App.vue.js")
  },
  {
    path: "/signin",
    component: () => import("../components/Auth/LoginForm/LoginForm.vue.js")
  }
];
let router;
let route;
const useRouter = () => router;
const useRoute = () => route;
const VueRouterPlugin = {
  install(app, options) {
    var _a, _b;
    const routetGlobal = ((_a = app.$nuxt) == null ? void 0 : _a.$router) || app.config.globalProperties.$router;
    if (routetGlobal) {
      router = routetGlobal;
    } else {
      router = createRouter({
        history: createWebHistory(),
        routes
      });
      app.use(router);
    }
    const routeGlobal = ((_b = app.$nuxt) == null ? void 0 : _b.$route) || app.config.globalProperties.$route;
    if (routeGlobal) {
      route = routeGlobal;
    } else {
      route = inject(routeLocationKey);
    }
  }
};
export {
  VueRouterPlugin as default,
  useRoute,
  useRouter
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
